module.exports = __webpack_public_path__ + "img/rodapeVerde.8985791b.png";